module.exports = __webpack_public_path__ + "static/media/edit.455ed2b3.svg";